import React from 'react';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import styles from './Landing.module.css';

function Landing() {
   ScrollToTop();
   return (
      <>
         <div className={styles.hero}>
            <div className={styles.heroTextContainer}>
               <h1 className={styles.heroText}>Xceed & Karnival</h1>
               <h2 className={styles.heroSubText}>We pave way for challenges which eventually transform to opportunities</h2>
            </div>
            <img className={styles.peaks} src={`${process.env.PUBLIC_URL}/layered-peaks.svg`} alt="" />
         </div>
      </>
   );
}

export default Landing;
